import React from "react";
import { useClasses } from "../../";
import classNames from "classnames";
import { styles as radiosStyles } from "./Radio";
const style = (theme) => {
    const radioClasses = radiosStyles(theme);
    return {
        radioLabel: radioClasses.radioLabel,
        radio: radioClasses.radio,
        radioIcon: radioClasses.radioIcon,
        radioPosition: radioClasses.radioPosition,
        radioIconSelected: radioClasses.radioIconSelected,
        helpBlock: radioClasses.helpBlock,
        hasError: radioClasses.hasError,
        radioIconError: {
            border: "3px solid " + theme.palette.get("danger"),
            borderColor: theme.palette.get("danger"),
            "& span": {
                backgroundColor: theme.palette.get("danger"),
            },
        },
    };
};
const RadioItem = (props) => {
    const { checked, value, label, onClick, hasError } = props;
    const classes = useClasses(style);
    return (React.createElement("label", { className: classes.radioLabel },
        label,
        React.createElement("input", { className: classNames([
                classes.radio,
                classes.radioPosition,
                hasError && classes.inputError,
            ]), type: "radio", checked: checked, value: value, onChange: (e) => onClick && onClick(value) }),
        React.createElement("span", { className: classNames([
                classes.radioIcon,
                classes.radioPosition,
                hasError && classes.radioIconError,
                checked && classes.radioIconSelected,
            ]) },
            React.createElement("span", null))));
};
export default RadioItem;
